import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dashboard-column-order-dialog',
  templateUrl: './dashboard-column-order-dialog.component.html',
  styleUrls: ['./dashboard-column-order-dialog.component.scss']
})
export class DashboardColumnOrderDialogComponent implements OnInit {

  constructor( public dialogRef: MatDialogRef<DashboardColumnOrderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) { }
   // displayedColumns = ['Worn','Customer', 'JobSite', 'Make', 'Type', 'SerialNo', 'AdditionalSerial', 'ImpBudget', 'Life','Residual', 'RemovelDate', 'Status','WarrantyStatus' ];     
    displayedColumns_:any

  ngOnInit() {
    
    this.displayedColumns_=this.data.displayedColumns
   // console.log(this.data.displayedColumns)
    //console.log(this.displayedColumns_)
  }

  onCloseClick(): void {
    this.dialogRef.close(this.displayedColumns_);
  }

  moveUp(id) { 
    if (id > 0) {
      let el = this.displayedColumns_[id];
      this.displayedColumns_[id] = this.displayedColumns_[id - 1];
      this.displayedColumns_[id - 1] = el;
    }
  }

  // move dwon by 1 postion in Array
  moveDown(id) {
    if (id !== -1 && id < this.displayedColumns_.length - 1) {
      let el = this.displayedColumns_[id];
      this.displayedColumns_[id] = this.displayedColumns_[id + 1];
      this.displayedColumns_[id + 1] = el;      
    console.log(id);
  }
 
}

isFirstComponentInList(item, index) {
  
  if (this.displayedColumns_.indexOf(item) == 0) {
      return true;
  }
  return false;
}

isLastComponentInList(item, index) {
  if (this.displayedColumns_.indexOf(item) == this.displayedColumns_.length - 1) {
      return true;
  }
  return false;
}

}
